import { useCallback } from 'react'
import { useConfigurationStore } from '@stores/configurationStore'
import { formatMoney as format } from '@utils/money'

/**
 * Returns a money formatter. By default it hides cents only when the global
 * `currencyHideCents` flag is set — the behaviour used for balance, win and
 * most amounts. Pass an explicit `hideCents` to override (e.g. jackpot-box-only
 * hiding, or always showing cents). For bet values that follow the multiple-of
 * rule, use `useFormatBetMoney` instead.
 */
const useFormatMoney = () => {
    const currencyHideCents = useConfigurationStore((s) => s.currencyHideCents)

    return useCallback(
        (amount: number, hideCents?: boolean) => format(amount, hideCents ?? currencyHideCents),
        [currencyHideCents]
    )
}

export default useFormatMoney
